// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1299px) {
    .Pages_wrap__RNd7Q {
        width: 100vw;
        padding: 84px 0 88px;
        min-height: calc(100vh - 231px);
    }

    .Pages_container__PBXjY {
        width: 100vw;
        margin: 0 auto;
    }

    .Pages_categoryContainer__bft\\+I {
        color: #222222;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages_commentContainer__h049w {
        text-align: center;
        display: flex;
        flex-flow: column;
        gap: 24px;
        margin: 62px 0 40px;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-delay: 0.6s;
        animation-fill-mode: both;
        /* letter-spacing: -0.7px; */
    }

    .Pages_commentTheme__8WO5p {
        color: #222222;
        font-size: 24px;
        font-weight: 600;
    }

    .Pages_commentContent__bd8-K {
        color: #434343;
        font-size: 14px;
        line-height: 24px;
        padding: 0 20px;
        word-break: keep-all;
        text-align: left;
    }

    .Pages_companyContainer__9wazD {
        display: flex;
        gap: 84px;
        padding: 0 20px;
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .Pages_companyContainer__9wazD::-webkit-scrollbar {
        display: block !important;
        height: 2px;
    }

    .Pages_companyContainer__9wazD::-webkit-scrollbar-button:start:decrement,
    .Pages_companyContainer__9wazD::-webkit-scrollbar-button:end:decrement {
        display: block;
        background-color: transparent;
        width: 20px;
    }
    .Pages_companyContainer__9wazD::-webkit-scrollbar-thumb {
        background-color: #A2A2A2;
        height: 2px;
    }

    .Pages_companyContainer__9wazD::-webkit-scrollbar-track {
        background-color: #DDDDDD;
    }

    .Pages_companyItem__CuDYU {
        min-width: 320px;
        display: flex;
        flex-flow: column;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
        margin-bottom: 40.27px;
    }

    .Pages_companyItemImg__-W6hB {
        position: relative;
        width: 200px;
        height: 200px;
        margin: 0 auto;
    }

    .Pages_companyItem__CuDYU:nth-child(1) { animation-delay: 1.2s }
    .Pages_companyItem__CuDYU:nth-child(2) { animation-delay: 1.3s }
    .Pages_companyItem__CuDYU:nth-child(3) { animation-delay: 1.4s }
    .Pages_companyItem__CuDYU:nth-child(4) { animation-delay: 1.5s }
    .Pages_companyItem__CuDYU:nth-child(5) { animation-delay: 1.6s }
    .Pages_companyItem__CuDYU:nth-child(6) { animation-delay: 1.7s }

    .Pages_companyItemImg__-W6hB > img {
        width: 200px;
    }

    #Pages_overlabB__hiGMR {
        opacity: 1;
        transition: 0.6s ease-out;
    }

    #Pages_overlabB__hiGMR:hover {
        opacity: 1;
    }

    #Pages_overlabR__H4Ue3 {
        opacity: 0;
        transition: 0.6s ease-out;
    }

    #Pages_overlabR__H4Ue3:hover {
        opacity: 1;
    }

    .Pages_companyItemTheme__MH6ms {
        color: #222222;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        margin: 40.73px 0 12px;
    }

    .Pages_companyItemContent__pAau4 {
        margin: 0 auto;
        color: #434343;
        font-size: 14px;
        line-height: 24px;
        word-break: keep-all;
        text-align: center;
    }

    @keyframes Pages_divUp__BSs7x {
        0% {
            opacity: 0;
            transform: translateY(40px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .Pages_productionContainer__xRb2Y {
        animation: Pages_divUp__BSs7x 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 1.2s;
        padding: 0 20px;
    }

    .Pages_productionContainer__xRb2Y:nth-child(n+2) {
        margin-top: 60px;
    }

    .Pages_productionTheme__aliXR {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
    }

    .Pages_productionTheme__aliXR > span {
        color: #222222;
        font-size: 20px;
        font-weight: bold;
        flex-shrink: 0;
    }

    .Pages_productionTheme__aliXR > hr {
        width: 100%;
        border: none;
        border-top: 1px solid #DC140A;
        height: 0;
        margin: 0;
    }
    .Pages_productionItemContainer__HbvaK {
        display: flex;
        flex-wrap: wrap;
        margin-top: 24px;
        gap: 16px;
    }

    .Pages_productionItem__HitZU {
        display: flex;
        width: 100%;
        height: 228px;
    }

    .Pages_productionItem__HitZU:nth-child(n) {
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages_productionItemImg__s3viy {
        width: 152px;
        height: 228px;
    }

    .Pages_productionItemImg__s3viy > img {
        width: inherit;
        height: inherit;
    }

    .Pages_productionItemInfoContainer__QLgLR {
        width: calc(100% - 152px);
        height: 228px;
        background-color: #FAFAFA;
        overflow: hidden;
    }

    .Pages_productionItemInfoWrap__RsUZz {
        width: calc(100% - 32px);
        height: 196px;
        overflow: auto;
        margin: 16px;
    }

    .Pages_productionItemInfoWrap__RsUZz::-webkit-scrollbar {
        width: 4px;
    }

    .Pages_productionItemInfoWrap__RsUZz::-webkit-scrollbar-thumb {
        background-color: #EAEAEA;
        border-radius: 20px;
    }

    .Pages_productionItemInfo__iCBZ7 {
        
    }

    .Pages_productionItemInfo__iCBZ7 hr {
        width: 100%;
        height: 1px;
        background-color: #DDDDDD;
        border: none;
        margin: 10px 0;
    }

    .Pages_productionItemTheme__nQbUk {
        color: #434343;
        font-size: 15px;
        font-weight: 600;
        white-space: pre-wrap;
        word-break: break-all;
    }

    .Pages_prodictionItemList__O\\+mkA > span {
        display: block;
    }

    .Pages_listTheme__IoSRf {
        color: #A2A2A2;
        font-size: 10px;
        font-weight: 500;
        margin-bottom: 2px;
    }

    .Pages_listContent__MGHwh {
        color: #434343;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        margin-bottom: 8px;
        white-space: pre-wrap;
        word-break: break-all;
    }

    .Pages_listContent__MGHwh:last-child {
        margin-bottom: 0;
    }

    .Pages_productionNodataContainer__n0FYs {
        margin-bottom: 160px;
        animation: Pages_divUp__BSs7x 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 1.2s;
    }

    .Pages_productionNoData__sf1eO {
        color: #222222;
        font-size: 16px;
        font-weight: 600;
        display: block;
        text-align: center;
        margin-top: 60px;
    }

    .Pages_producerItem__Jk9QW {
        width: 100%;
        height: 136px;
        display: flex;
        gap: 24px;
        padding: 20px 0;
        flex-direction: column;
        transition: 0.3s ease-out;
        border-bottom: #F4F4F4 1px solid;
        position: relative;
    }

    .Pages_producerItem__Jk9QW:nth-child(1) {
        margin-top: -40px;
    }

    .Pages_producerItemInfo__c1vbF {
        display: flex;
        gap: 16px;
    }

    .Pages_producerItemInfo__c1vbF img {
        width: 96px;
        height: 96px;
    }

    .Pages_producerItemName__aeOn7 {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .Pages_producerItemName__aeOn7 > span:nth-child(1) {
        color: #222222;
        font-weight: 500;
        font-size: 12px;
    }

    .Pages_producerItemName__aeOn7 > span:nth-child(2) {
        color: #222222;
        font-weight: 600;
        font-size: 18px;
    }

    .Pages_producerItemWork__kPKTF {
        color: #222222;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        gap: 8px;
        flex-direction: column;
        width: 100%;
        position: relative;
        overflow-y: hidden;
    }

    .Pages_listArrow__0vfMo {
        position: absolute;
        width: 16px;
        height: 8px;
        right: 0;
        bottom: 20px;
        cursor: pointer;
    }

    .Pages_workItem__HSQLQ > span {
        color: #434343;
        font-size: 12px;
        font-weight: 400;
        display: block;
        line-height: 20px;
    }

    .Pages_auditionForm__CYyLP {
        width: calc(100vw - 40px);
        margin: 0 auto;
        border-top: 2px solid #DC140A;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
        animation-delay: 0.6s;
    }

    .Pages_auditionItem__pAw7q {
        display: flex;
        flex-direction: column;
    }

    .Pages_auditionItem__pAw7q:nth-child(n+2) {
        border-bottom: 2px solid rgba(43, 43, 43, 0.2);
        flex-direction: row;
    }

    .Pages_auditionItem__pAw7q:last-child {
        border: none;
    }

    .Pages_auditionItemDiv__NAORU {
        border-bottom: 2px solid rgba(43, 43, 43, 0.2);
        display: flex;
        align-items: center;
        gap: 32px;
    }

    .Pages_auditionTheme__HNY-S {
        font-size: 16px;
        font-weight: bold;
        color: #222222;
        width: 100px;
        padding: 24px 0 24px 8px;
        flex-shrink: 0;
    }

    .Pages_auditionContent__u-ecD {
        font-size: 16px;
        font-weight: 500;
        min-width: 208px;
        color: #222222;
        padding: 24px 0 24px 10px;
        display: flex;
        flex-flow: column;
        gap: 19px;
    }

    .Pages_auditionItem__pAw7q:nth-child(3) .Pages_auditionContent__u-ecD {
        flex-shrink: 0;
        flex-wrap: wrap;
        gap: 24px;
    }

    .Pages_auditionContentSpace__wR2NT {
        display: flex;
        gap: 20px;
    }

    .Pages_auditionContentSpace__wR2NT > span:nth-child(1) {
        width: 14px;
    }

    .Pages_auditionContentSpace__wR2NT > span:nth-child(2) {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .Pages_auditionContentEx__pfGoi {
        font-size: 12px;
        color: #434343;
    }

    .Pages_auditionContentFlex__UuRTO {
        display: flex;
        gap: 10px;
        flex-flow: column;
        min-width: 208px;
    }

    .Pages_flexContent2__vkP09 > span {
        display: block;
        line-height: 40px;
        color: #434343;
        font-size: 12px;
        font-weight: 400;
        max-width: 208px;
    }

    .Pages_flexContent__RI7a0 > span {
        display: block;
        line-height: 20px;
        color: #434343;
        font-size: 12px;
        font-weight: 400;
        max-width: 208px;
        word-break: keep-all;
        text-indent: -8px;
        padding-left: 8px;
    }

    .Pages_flexButton__OKJh0 {
        margin-top: 24px;
        display: flex;
        gap: 10px 15px;
        flex-wrap: wrap;
    }

    .Pages_downloadButton__mP1d9 {
        background-color: #DC140A;
        width: auto;
        height: 25px;
        border-radius: 13px;
        color: #FFFFFF;
        font-size: 12px;
        font-weight: bold;
        padding: 5px 16px;
        display: flex;
        justify-content: center;
        gap: 8px;
        align-items: center;
        cursor: pointer;
    }

    .Pages_downloadButton__mP1d9 > img {
        width: 10px;
    }

    .Pages_companyScrollBarContainer__IfJHC {
        width: 100vw;
        padding: 0 20px;
        margin: 40.27px 0 88px;
        height: 8px;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-delay: 0.6s;
        animation-fill-mode: both;
    }

    .Pages_companyScrollBar__pNuJh {
        position: relative;
        background-color: #DDDDDD;
        border: none;
        height: 1px;
    }

    .Pages_companyScrollBarShow__B455J {
        position: absolute;
        background-color: #A2A2A2;
        border: none;
        height: 2px;
        width: 0;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        transition: 0.3s ease-out;
    }
}

@media only screen and (min-width: 1300px) {
    .Pages_wrap__RNd7Q {
        width: 100%;
        padding: 148px 0 240px;
    }

    .Pages_container__PBXjY {
        width: 1300px;
        margin: 0 auto;
    }

    .Pages_categoryContainer__bft\\+I {
        color: #222222;
        font-size: 64px;
        font-weight: bold;
        text-align: center;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages_commentContainer__h049w {
        text-align: center;
        display: flex;
        flex-flow: column;
        gap: 24px;
        margin: 80px 0 160px;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-delay: 0.6s;
        animation-fill-mode: both;
        /* letter-spacing: -0.7px; */
    }

    .Pages_commentTheme__8WO5p {
        color: #222222;
        font-size: 40px;
        font-weight: 600;
    }

    .Pages_commentContent__bd8-K {
        color: #434343;
        font-size: 26px;
        line-height: 44px;
        width: 1000px;
        margin: 0 auto;
        word-break: keep-all;
        text-align: left;
    }

    
    .Pages_productionComment__Z7MMn {
        width: 900px;
    }

    .Pages_companyContainer__9wazD {
        display: flex;
        gap: 160px 20px;
        flex-wrap: wrap;
    }

    .Pages_companyItem__CuDYU {
        height: 855px;
        display: flex;
        flex-flow: column;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages_companyItem__CuDYU:nth-child(3n-2) {
        justify-content: flex-start;
    }

    .Pages_companyItem__CuDYU:nth-child(3n-1) {
        justify-content: center;
    }

    .Pages_companyItem__CuDYU:nth-child(3n) {
        justify-content: flex-end;
    }

    .Pages_companyItemImg__-W6hB {
        position: relative;
        width: 420px;
        height: 280px;
    }

    .Pages_companyItem__CuDYU:nth-child(1) { animation-delay: 1.2s }
    .Pages_companyItem__CuDYU:nth-child(2) { animation-delay: 1.3s }
    .Pages_companyItem__CuDYU:nth-child(3) { animation-delay: 1.4s }
    .Pages_companyItem__CuDYU:nth-child(4) { animation-delay: 1.5s }
    .Pages_companyItem__CuDYU:nth-child(5) { animation-delay: 1.6s }
    .Pages_companyItem__CuDYU:nth-child(6) { animation-delay: 1.7s }

    .Pages_companyItemImg__-W6hB > img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    #Pages_overlabB__hiGMR {
        opacity: 1;
        transition: 0.6s ease-out;
    }

    #Pages_overlabB__hiGMR:hover {
        opacity: 1;
    }

    #Pages_overlabR__H4Ue3 {
        opacity: 0;
        transition: 0.6s ease-out;
    }

    #Pages_overlabR__H4Ue3:hover {
        opacity: 1;
    }

    .Pages_companyItemTheme__MH6ms {
        color: #222222;
        font-size: 40px;
        font-weight: 600;
        text-align: center;
        margin: 65px 0 24px;
    }

    .Pages_companyItemContent__pAau4 {
        width: 400px;
        color: #434343;
        font-size: 26px;
        line-height: 44px;
        word-break: keep-all;
        text-align: center;
    }

    @keyframes Pages_divUp__BSs7x {
        0% {
            opacity: 0;
            transform: translateY(40px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .Pages_productionContainer__xRb2Y {
        animation: Pages_divUp__BSs7x 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 1.2s;
    }

    .Pages_productionContainer__xRb2Y:nth-child(n+2) {
        margin-top: 160px;
    }

    .Pages_productionTheme__aliXR {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 46px;
    }

    .Pages_productionTheme__aliXR > span {
        color: #222222;
        font-size: 56px;
        font-weight: bold;
    }

    .Pages_productionTheme__aliXR > hr {
        width: 1080px;
        border: none;
        border-top: 1px solid #DC140A;
        height: 0;
        margin: 0;
    }

    .Pages_productionItemContainer__HbvaK {
        display: flex;
        flex-wrap: wrap;
        margin-top: 48px;
        gap: 20px;
    }

    .Pages_productionItem__HitZU {
        display: flex;
        width: 640px;
        height: 465px;
    }

    .Pages_productionItem__HitZU:nth-child(n) {
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages_productionItemImg__s3viy {
        width: 310px;
        height: 465px;
    }

    .Pages_productionItemImg__s3viy > img {
        width: inherit;
        height: inherit;
    }

    .Pages_productionItemInfoContainer__QLgLR {
        width: 330px;
        height: 465px;
        background-color: #FAFAFA;
        overflow: hidden;
    }

    .Pages_productionItemInfoWrap__RsUZz {
        width: 290px;
        height: 413px;
        overflow: auto;
        margin: 26px 20px;
    }

    .Pages_productionItemInfoWrap__RsUZz::-webkit-scrollbar {
        width: 8px;
    }

    .Pages_productionItemInfoWrap__RsUZz::-webkit-scrollbar-thumb {
        background-color: #EAEAEA;
        border-radius: 20px;
    }

    .Pages_productionItemInfo__iCBZ7 {
        
    }

    .Pages_productionItemInfo__iCBZ7 hr {
        width: 280px;
        height: 1px;
        background-color: #DDDDDD;
        border: none;
        margin: 24px 0;
    }

    .Pages_productionItemTheme__nQbUk {
        color: #434343;
        font-size: 32px;
        font-weight: 600;
        white-space: pre-wrap;
        word-break: break-all;
    }

    .Pages_prodictionItemList__O\\+mkA > span {
        display: block;
    }

    .Pages_listTheme__IoSRf {
        color: #A2A2A2;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 4px;
    }

    .Pages_listContent__MGHwh {
        color: #434343;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 16px;
        white-space: pre-wrap;
        word-break: break-all;
    }

    .Pages_listContent__MGHwh:last-child {
        margin-bottom: 0;
    }

    .Pages_productionNodataContainer__n0FYs {
        margin-bottom: 160px;
        animation: Pages_divUp__BSs7x 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 1.2s;
    }

    .Pages_productionNoData__sf1eO {
        color: #222222;
        font-size: 40px;
        font-weight: 600;
        display: block;
        text-align: center;
        margin-top: 120px;
    }

    .Pages_producerItem__Jk9QW {
        width: 1300px;
        height: 248px;
        display: flex;
        gap: 20px;
        padding: 44px 0;
        transition: 0.3s ease-out;
        border-bottom: #F4F4F4 1px solid;
        position: relative;
    }

    .Pages_producerItemInfo__c1vbF {
        display: flex;
        gap: 60px;
    }

    .Pages_producerItemInfo__c1vbF img {
        width: 160px;
        height: 160px;
    }

    .Pages_producerItemName__aeOn7 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 420px;
    }

    .Pages_producerItemName__aeOn7 > span:nth-child(1) {
        color: #222222;
        font-weight: 500;
        font-size: 30px;
    }

    .Pages_producerItemName__aeOn7 > span:nth-child(2) {
        color: #222222;
        font-weight: 600;
        font-size: 40px;
    }

    .Pages_producerItemWork__kPKTF {
        color: #222222;
        font-size: 30px;
        font-weight: 500;
        display: flex;
        gap: 14px;
        flex-direction: column;
        width: 640px;
        position: relative;
        overflow-y: hidden;
    }

    .Pages_listArrow__0vfMo {
        position: absolute;
        width: 40px;
        height: 20px;
        right: 24px;
        bottom: 52px;
        cursor: pointer;
    }

    .Pages_workItem__HSQLQ > span {
        color: #434343;
        font-size: 24px;
        font-weight: 400;
        display: block;
        line-height: 40px;
    }

    .Pages_auditionForm__CYyLP {
        width: 1300px;
        margin: 0 auto;
        border-top: 2px solid #DC140A;
        animation: Pages_divUp__BSs7x 0.6s ease-in-out;
        animation-fill-mode: both;
        animation-delay: 0.6s;
    }

    .Pages_auditionItem__pAw7q {
        display: flex;
        gap: 20px;
    }

    .Pages_auditionItem__pAw7q:nth-child(n+2) {
        border-bottom: 2px solid rgba(43, 43, 43, 0.2);
    }

    .Pages_auditionItem__pAw7q:last-child {
        border: none;
    }

    .Pages_auditionItemDiv__NAORU {
        width: 640px;
        border-bottom: 2px solid rgba(43, 43, 43, 0.2);
        display: flex;
        align-items: center;
        gap: 20px;
    }

    .Pages_auditionTheme__HNY-S {
        font-size: 32px;
        font-weight: bold;
        color: #222222;
        width: 200px;
        padding: 60px 0 60px 32px;
    }

    .Pages_auditionContent__u-ecD {
        font-size: 32px;
        font-weight: 500;
        min-width: 420px;
        color: #222222;
        padding: 60px 0 60px 20px;
        display: flex;
        flex-flow: column;
        gap: 27px;
    }

    .Pages_auditionItem__pAw7q:nth-child(3) .Pages_auditionContent__u-ecD {
        max-width: 1080px;
        flex-flow: row;
        flex-shrink: 0;
        flex-wrap: wrap;
        gap: 60px 27px;
    }

    .Pages_auditionContentSpace__wR2NT {
        display: flex;
        gap: 32px;
    }

    .Pages_auditionContentSpace__wR2NT > span:nth-child(1) {
        width: 35px;
    }

    .Pages_auditionContentEx__pfGoi {
        font-size: 26px;
        color: #434343;
    }

    .Pages_auditionContentFlex__UuRTO {
        display: flex;
        gap: 24px;
        flex-flow: column;
        min-width: 420px;;
    }

    .Pages_flexContent2__vkP09 > span {
        display: block;
        line-height: 40px;
        color: #434343;
        font-size: 26px;
        font-weight: 400;
        width: 420px;
    }

    .Pages_flexContent__RI7a0 > span {
        display: block;
        line-height: 40px;
        color: #434343;
        font-size: 26px;
        font-weight: 400;
    }

    .Pages_flexButton__OKJh0 {
        margin-top: 36px;
        display: flex;
        gap: 16px;
    }

    .Pages_downloadButton__mP1d9 {
        background-color: #DC140A;
        width: auto;
        height: 43px;
        border-radius: 21px;
        color: #FFFFFF;
        font-size: 20px;
        font-weight: bold;
        padding: 0 32px;
        display: flex;
        justify-content: center;
        gap: 16px;
        align-items: center;
        cursor: pointer;
    }

    .Pages_companyScrollBarContainer__IfJHC {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Pages.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,oBAAoB;QACpB,+BAA+B;IACnC;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,8CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,mBAAmB;QACnB,8CAAiC;QACjC,qBAAqB;QACrB,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;IACf;;IAEA;;QAEI,cAAc;QACd,6BAA6B;QAC7B,WAAW;IACf;IACA;QACI,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,iBAAiB;QACjB,8CAAiC;QACjC,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,cAAc;IAClB;;IAEA,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;;IAElD;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI;YACI,UAAU;YACV,2BAA2B;QAC/B;QACA;YACI,UAAU;YACV,wBAAwB;QAC5B;IACJ;;IAEA;QACI,2CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,SAAS;QACT,SAAS;IACb;IACA;QACI,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,8CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,aAAa;QACb,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;QACxB,aAAa;QACb,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;;IAEA;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,qBAAqB;QACrB,qBAAqB;IACzB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,qBAAqB;QACrB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,2CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,aAAa;QACb,SAAS;QACT,eAAe;QACf,sBAAsB;QACtB,yBAAyB;QACzB,gCAAgC;QAChC,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,QAAQ;QACR,sBAAsB;QACtB,WAAW;QACX,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,QAAQ;QACR,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,6BAA6B;QAC7B,8CAAiC;QACjC,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,8CAA8C;QAC9C,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,8CAA8C;QAC9C,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,YAAY;QACZ,wBAAwB;QACxB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,yBAAyB;QACzB,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,SAAS;IACb;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,aAAa;QACb,uBAAuB;QACvB,QAAQ;QACR,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,sBAAsB;QACtB,WAAW;QACX,8CAAiC;QACjC,qBAAqB;QACrB,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,WAAW;QACX,QAAQ;QACR,OAAO;QACP,QAAQ;QACR,2BAA2B;QAC3B,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,8CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,oBAAoB;QACpB,8CAAiC;QACjC,qBAAqB;QACrB,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,cAAc;QACd,oBAAoB;QACpB,gBAAgB;IACpB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,aAAa;QACb,iBAAiB;QACjB,8CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;IACjB;;IAEA,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;IAClD,yCAA4B,sBAAsB;;IAElD;QACI,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gCAAgC;IACpC;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI;YACI,UAAU;YACV,2BAA2B;QAC/B;QACA;YACI,UAAU;YACV,wBAAwB;QAC5B;IACJ;;IAEA;QACI,2CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,6BAA6B;QAC7B,SAAS;QACT,SAAS;IACb;;IAEA;QACI,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,8CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;;IAEA;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,qBAAqB;QACrB,qBAAqB;IACzB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,qBAAqB;QACrB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,2CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,aAAa;QACb,aAAa;QACb,SAAS;QACT,eAAe;QACf,yBAAyB;QACzB,gCAAgC;QAChC,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,SAAS;QACT,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,6BAA6B;QAC7B,8CAAiC;QACjC,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,8CAA8C;QAC9C,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,yBAAyB;QACzB,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,SAAS;IACb;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@media only screen and (max-width: 1299px) {\n    .wrap {\n        width: 100vw;\n        padding: 84px 0 88px;\n        min-height: calc(100vh - 231px);\n    }\n\n    .container {\n        width: 100vw;\n        margin: 0 auto;\n    }\n\n    .categoryContainer {\n        color: #222222;\n        font-size: 32px;\n        font-weight: bold;\n        text-align: center;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .commentContainer {\n        text-align: center;\n        display: flex;\n        flex-flow: column;\n        gap: 24px;\n        margin: 62px 0 40px;\n        animation: divUp 0.6s ease-in-out;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n        /* letter-spacing: -0.7px; */\n    }\n\n    .commentTheme {\n        color: #222222;\n        font-size: 24px;\n        font-weight: 600;\n    }\n\n    .commentContent {\n        color: #434343;\n        font-size: 14px;\n        line-height: 24px;\n        padding: 0 20px;\n        word-break: keep-all;\n        text-align: left;\n    }\n\n    .companyContainer {\n        display: flex;\n        gap: 84px;\n        padding: 0 20px;\n        overflow-x: scroll;\n        overflow-y: hidden;\n    }\n\n    .companyContainer::-webkit-scrollbar {\n        display: block !important;\n        height: 2px;\n    }\n\n    .companyContainer::-webkit-scrollbar-button:start:decrement,\n    .companyContainer::-webkit-scrollbar-button:end:decrement {\n        display: block;\n        background-color: transparent;\n        width: 20px;\n    }\n    .companyContainer::-webkit-scrollbar-thumb {\n        background-color: #A2A2A2;\n        height: 2px;\n    }\n\n    .companyContainer::-webkit-scrollbar-track {\n        background-color: #DDDDDD;\n    }\n\n    .companyItem {\n        min-width: 320px;\n        display: flex;\n        flex-flow: column;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n        margin-bottom: 40.27px;\n    }\n\n    .companyItemImg {\n        position: relative;\n        width: 200px;\n        height: 200px;\n        margin: 0 auto;\n    }\n\n    .companyItem:nth-child(1) { animation-delay: 1.2s }\n    .companyItem:nth-child(2) { animation-delay: 1.3s }\n    .companyItem:nth-child(3) { animation-delay: 1.4s }\n    .companyItem:nth-child(4) { animation-delay: 1.5s }\n    .companyItem:nth-child(5) { animation-delay: 1.6s }\n    .companyItem:nth-child(6) { animation-delay: 1.7s }\n\n    .companyItemImg > img {\n        width: 200px;\n    }\n\n    #overlabB {\n        opacity: 1;\n        transition: 0.6s ease-out;\n    }\n\n    #overlabB:hover {\n        opacity: 1;\n    }\n\n    #overlabR {\n        opacity: 0;\n        transition: 0.6s ease-out;\n    }\n\n    #overlabR:hover {\n        opacity: 1;\n    }\n\n    .companyItemTheme {\n        color: #222222;\n        font-size: 16px;\n        font-weight: 600;\n        text-align: center;\n        margin: 40.73px 0 12px;\n    }\n\n    .companyItemContent {\n        margin: 0 auto;\n        color: #434343;\n        font-size: 14px;\n        line-height: 24px;\n        word-break: keep-all;\n        text-align: center;\n    }\n\n    @keyframes divUp {\n        0% {\n            opacity: 0;\n            transform: translateY(40px);\n        }\n        100% {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .productionContainer {\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 1.2s;\n        padding: 0 20px;\n    }\n\n    .productionContainer:nth-child(n+2) {\n        margin-top: 60px;\n    }\n\n    .productionTheme {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 12px;\n    }\n\n    .productionTheme > span {\n        color: #222222;\n        font-size: 20px;\n        font-weight: bold;\n        flex-shrink: 0;\n    }\n\n    .productionTheme > hr {\n        width: 100%;\n        border: none;\n        border-top: 1px solid #DC140A;\n        height: 0;\n        margin: 0;\n    }\n    .productionItemContainer {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 24px;\n        gap: 16px;\n    }\n\n    .productionItem {\n        display: flex;\n        width: 100%;\n        height: 228px;\n    }\n\n    .productionItem:nth-child(n) {\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .productionItemImg {\n        width: 152px;\n        height: 228px;\n    }\n\n    .productionItemImg > img {\n        width: inherit;\n        height: inherit;\n    }\n\n    .productionItemInfoContainer {\n        width: calc(100% - 152px);\n        height: 228px;\n        background-color: #FAFAFA;\n        overflow: hidden;\n    }\n\n    .productionItemInfoWrap {\n        width: calc(100% - 32px);\n        height: 196px;\n        overflow: auto;\n        margin: 16px;\n    }\n\n    .productionItemInfoWrap::-webkit-scrollbar {\n        width: 4px;\n    }\n\n    .productionItemInfoWrap::-webkit-scrollbar-thumb {\n        background-color: #EAEAEA;\n        border-radius: 20px;\n    }\n\n    .productionItemInfo {\n        \n    }\n\n    .productionItemInfo hr {\n        width: 100%;\n        height: 1px;\n        background-color: #DDDDDD;\n        border: none;\n        margin: 10px 0;\n    }\n\n    .productionItemTheme {\n        color: #434343;\n        font-size: 15px;\n        font-weight: 600;\n        white-space: pre-wrap;\n        word-break: break-all;\n    }\n\n    .prodictionItemList > span {\n        display: block;\n    }\n\n    .listTheme {\n        color: #A2A2A2;\n        font-size: 10px;\n        font-weight: 500;\n        margin-bottom: 2px;\n    }\n\n    .listContent {\n        color: #434343;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 16px;\n        margin-bottom: 8px;\n        white-space: pre-wrap;\n        word-break: break-all;\n    }\n\n    .listContent:last-child {\n        margin-bottom: 0;\n    }\n\n    .productionNodataContainer {\n        margin-bottom: 160px;\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 1.2s;\n    }\n\n    .productionNoData {\n        color: #222222;\n        font-size: 16px;\n        font-weight: 600;\n        display: block;\n        text-align: center;\n        margin-top: 60px;\n    }\n\n    .producerItem {\n        width: 100%;\n        height: 136px;\n        display: flex;\n        gap: 24px;\n        padding: 20px 0;\n        flex-direction: column;\n        transition: 0.3s ease-out;\n        border-bottom: #F4F4F4 1px solid;\n        position: relative;\n    }\n\n    .producerItem:nth-child(1) {\n        margin-top: -40px;\n    }\n\n    .producerItemInfo {\n        display: flex;\n        gap: 16px;\n    }\n\n    .producerItemInfo img {\n        width: 96px;\n        height: 96px;\n    }\n\n    .producerItemName {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .producerItemName > span:nth-child(1) {\n        color: #222222;\n        font-weight: 500;\n        font-size: 12px;\n    }\n\n    .producerItemName > span:nth-child(2) {\n        color: #222222;\n        font-weight: 600;\n        font-size: 18px;\n    }\n\n    .producerItemWork {\n        color: #222222;\n        font-size: 16px;\n        font-weight: 500;\n        display: flex;\n        gap: 8px;\n        flex-direction: column;\n        width: 100%;\n        position: relative;\n        overflow-y: hidden;\n    }\n\n    .listArrow {\n        position: absolute;\n        width: 16px;\n        height: 8px;\n        right: 0;\n        bottom: 20px;\n        cursor: pointer;\n    }\n\n    .workItem > span {\n        color: #434343;\n        font-size: 12px;\n        font-weight: 400;\n        display: block;\n        line-height: 20px;\n    }\n\n    .auditionForm {\n        width: calc(100vw - 40px);\n        margin: 0 auto;\n        border-top: 2px solid #DC140A;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n        animation-delay: 0.6s;\n    }\n\n    .auditionItem {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .auditionItem:nth-child(n+2) {\n        border-bottom: 2px solid rgba(43, 43, 43, 0.2);\n        flex-direction: row;\n    }\n\n    .auditionItem:last-child {\n        border: none;\n    }\n\n    .auditionItemDiv {\n        border-bottom: 2px solid rgba(43, 43, 43, 0.2);\n        display: flex;\n        align-items: center;\n        gap: 32px;\n    }\n\n    .auditionTheme {\n        font-size: 16px;\n        font-weight: bold;\n        color: #222222;\n        width: 100px;\n        padding: 24px 0 24px 8px;\n        flex-shrink: 0;\n    }\n\n    .auditionContent {\n        font-size: 16px;\n        font-weight: 500;\n        min-width: 208px;\n        color: #222222;\n        padding: 24px 0 24px 10px;\n        display: flex;\n        flex-flow: column;\n        gap: 19px;\n    }\n\n    .auditionItem:nth-child(3) .auditionContent {\n        flex-shrink: 0;\n        flex-wrap: wrap;\n        gap: 24px;\n    }\n\n    .auditionContentSpace {\n        display: flex;\n        gap: 20px;\n    }\n\n    .auditionContentSpace > span:nth-child(1) {\n        width: 14px;\n    }\n\n    .auditionContentSpace > span:nth-child(2) {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .auditionContentEx {\n        font-size: 12px;\n        color: #434343;\n    }\n\n    .auditionContentFlex {\n        display: flex;\n        gap: 10px;\n        flex-flow: column;\n        min-width: 208px;\n    }\n\n    .flexContent2 > span {\n        display: block;\n        line-height: 40px;\n        color: #434343;\n        font-size: 12px;\n        font-weight: 400;\n        max-width: 208px;\n    }\n\n    .flexContent > span {\n        display: block;\n        line-height: 20px;\n        color: #434343;\n        font-size: 12px;\n        font-weight: 400;\n        max-width: 208px;\n        word-break: keep-all;\n        text-indent: -8px;\n        padding-left: 8px;\n    }\n\n    .flexButton {\n        margin-top: 24px;\n        display: flex;\n        gap: 10px 15px;\n        flex-wrap: wrap;\n    }\n\n    .downloadButton {\n        background-color: #DC140A;\n        width: auto;\n        height: 25px;\n        border-radius: 13px;\n        color: #FFFFFF;\n        font-size: 12px;\n        font-weight: bold;\n        padding: 5px 16px;\n        display: flex;\n        justify-content: center;\n        gap: 8px;\n        align-items: center;\n        cursor: pointer;\n    }\n\n    .downloadButton > img {\n        width: 10px;\n    }\n\n    .companyScrollBarContainer {\n        width: 100vw;\n        padding: 0 20px;\n        margin: 40.27px 0 88px;\n        height: 8px;\n        animation: divUp 0.6s ease-in-out;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n    }\n\n    .companyScrollBar {\n        position: relative;\n        background-color: #DDDDDD;\n        border: none;\n        height: 1px;\n    }\n\n    .companyScrollBarShow {\n        position: absolute;\n        background-color: #A2A2A2;\n        border: none;\n        height: 2px;\n        width: 0;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        transition: 0.3s ease-out;\n    }\n}\n\n@media only screen and (min-width: 1300px) {\n    .wrap {\n        width: 100%;\n        padding: 148px 0 240px;\n    }\n\n    .container {\n        width: 1300px;\n        margin: 0 auto;\n    }\n\n    .categoryContainer {\n        color: #222222;\n        font-size: 64px;\n        font-weight: bold;\n        text-align: center;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .commentContainer {\n        text-align: center;\n        display: flex;\n        flex-flow: column;\n        gap: 24px;\n        margin: 80px 0 160px;\n        animation: divUp 0.6s ease-in-out;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n        /* letter-spacing: -0.7px; */\n    }\n\n    .commentTheme {\n        color: #222222;\n        font-size: 40px;\n        font-weight: 600;\n    }\n\n    .commentContent {\n        color: #434343;\n        font-size: 26px;\n        line-height: 44px;\n        width: 1000px;\n        margin: 0 auto;\n        word-break: keep-all;\n        text-align: left;\n    }\n\n    \n    .productionComment {\n        width: 900px;\n    }\n\n    .companyContainer {\n        display: flex;\n        gap: 160px 20px;\n        flex-wrap: wrap;\n    }\n\n    .companyItem {\n        height: 855px;\n        display: flex;\n        flex-flow: column;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .companyItem:nth-child(3n-2) {\n        justify-content: flex-start;\n    }\n\n    .companyItem:nth-child(3n-1) {\n        justify-content: center;\n    }\n\n    .companyItem:nth-child(3n) {\n        justify-content: flex-end;\n    }\n\n    .companyItemImg {\n        position: relative;\n        width: 420px;\n        height: 280px;\n    }\n\n    .companyItem:nth-child(1) { animation-delay: 1.2s }\n    .companyItem:nth-child(2) { animation-delay: 1.3s }\n    .companyItem:nth-child(3) { animation-delay: 1.4s }\n    .companyItem:nth-child(4) { animation-delay: 1.5s }\n    .companyItem:nth-child(5) { animation-delay: 1.6s }\n    .companyItem:nth-child(6) { animation-delay: 1.7s }\n\n    .companyItemImg > img {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    }\n\n    #overlabB {\n        opacity: 1;\n        transition: 0.6s ease-out;\n    }\n\n    #overlabB:hover {\n        opacity: 1;\n    }\n\n    #overlabR {\n        opacity: 0;\n        transition: 0.6s ease-out;\n    }\n\n    #overlabR:hover {\n        opacity: 1;\n    }\n\n    .companyItemTheme {\n        color: #222222;\n        font-size: 40px;\n        font-weight: 600;\n        text-align: center;\n        margin: 65px 0 24px;\n    }\n\n    .companyItemContent {\n        width: 400px;\n        color: #434343;\n        font-size: 26px;\n        line-height: 44px;\n        word-break: keep-all;\n        text-align: center;\n    }\n\n    @keyframes divUp {\n        0% {\n            opacity: 0;\n            transform: translateY(40px);\n        }\n        100% {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .productionContainer {\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 1.2s;\n    }\n\n    .productionContainer:nth-child(n+2) {\n        margin-top: 160px;\n    }\n\n    .productionTheme {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 46px;\n    }\n\n    .productionTheme > span {\n        color: #222222;\n        font-size: 56px;\n        font-weight: bold;\n    }\n\n    .productionTheme > hr {\n        width: 1080px;\n        border: none;\n        border-top: 1px solid #DC140A;\n        height: 0;\n        margin: 0;\n    }\n\n    .productionItemContainer {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 48px;\n        gap: 20px;\n    }\n\n    .productionItem {\n        display: flex;\n        width: 640px;\n        height: 465px;\n    }\n\n    .productionItem:nth-child(n) {\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .productionItemImg {\n        width: 310px;\n        height: 465px;\n    }\n\n    .productionItemImg > img {\n        width: inherit;\n        height: inherit;\n    }\n\n    .productionItemInfoContainer {\n        width: 330px;\n        height: 465px;\n        background-color: #FAFAFA;\n        overflow: hidden;\n    }\n\n    .productionItemInfoWrap {\n        width: 290px;\n        height: 413px;\n        overflow: auto;\n        margin: 26px 20px;\n    }\n\n    .productionItemInfoWrap::-webkit-scrollbar {\n        width: 8px;\n    }\n\n    .productionItemInfoWrap::-webkit-scrollbar-thumb {\n        background-color: #EAEAEA;\n        border-radius: 20px;\n    }\n\n    .productionItemInfo {\n        \n    }\n\n    .productionItemInfo hr {\n        width: 280px;\n        height: 1px;\n        background-color: #DDDDDD;\n        border: none;\n        margin: 24px 0;\n    }\n\n    .productionItemTheme {\n        color: #434343;\n        font-size: 32px;\n        font-weight: 600;\n        white-space: pre-wrap;\n        word-break: break-all;\n    }\n\n    .prodictionItemList > span {\n        display: block;\n    }\n\n    .listTheme {\n        color: #A2A2A2;\n        font-size: 14px;\n        font-weight: 500;\n        margin-bottom: 4px;\n    }\n\n    .listContent {\n        color: #434343;\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 28px;\n        margin-bottom: 16px;\n        white-space: pre-wrap;\n        word-break: break-all;\n    }\n\n    .listContent:last-child {\n        margin-bottom: 0;\n    }\n\n    .productionNodataContainer {\n        margin-bottom: 160px;\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 1.2s;\n    }\n\n    .productionNoData {\n        color: #222222;\n        font-size: 40px;\n        font-weight: 600;\n        display: block;\n        text-align: center;\n        margin-top: 120px;\n    }\n\n    .producerItem {\n        width: 1300px;\n        height: 248px;\n        display: flex;\n        gap: 20px;\n        padding: 44px 0;\n        transition: 0.3s ease-out;\n        border-bottom: #F4F4F4 1px solid;\n        position: relative;\n    }\n\n    .producerItemInfo {\n        display: flex;\n        gap: 60px;\n    }\n\n    .producerItemInfo img {\n        width: 160px;\n        height: 160px;\n    }\n\n    .producerItemName {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        width: 420px;\n    }\n\n    .producerItemName > span:nth-child(1) {\n        color: #222222;\n        font-weight: 500;\n        font-size: 30px;\n    }\n\n    .producerItemName > span:nth-child(2) {\n        color: #222222;\n        font-weight: 600;\n        font-size: 40px;\n    }\n\n    .producerItemWork {\n        color: #222222;\n        font-size: 30px;\n        font-weight: 500;\n        display: flex;\n        gap: 14px;\n        flex-direction: column;\n        width: 640px;\n        position: relative;\n        overflow-y: hidden;\n    }\n\n    .listArrow {\n        position: absolute;\n        width: 40px;\n        height: 20px;\n        right: 24px;\n        bottom: 52px;\n        cursor: pointer;\n    }\n\n    .workItem > span {\n        color: #434343;\n        font-size: 24px;\n        font-weight: 400;\n        display: block;\n        line-height: 40px;\n    }\n\n    .auditionForm {\n        width: 1300px;\n        margin: 0 auto;\n        border-top: 2px solid #DC140A;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n        animation-delay: 0.6s;\n    }\n\n    .auditionItem {\n        display: flex;\n        gap: 20px;\n    }\n\n    .auditionItem:nth-child(n+2) {\n        border-bottom: 2px solid rgba(43, 43, 43, 0.2);\n    }\n\n    .auditionItem:last-child {\n        border: none;\n    }\n\n    .auditionItemDiv {\n        width: 640px;\n        border-bottom: 2px solid rgba(43, 43, 43, 0.2);\n        display: flex;\n        align-items: center;\n        gap: 20px;\n    }\n\n    .auditionTheme {\n        font-size: 32px;\n        font-weight: bold;\n        color: #222222;\n        width: 200px;\n        padding: 60px 0 60px 32px;\n    }\n\n    .auditionContent {\n        font-size: 32px;\n        font-weight: 500;\n        min-width: 420px;\n        color: #222222;\n        padding: 60px 0 60px 20px;\n        display: flex;\n        flex-flow: column;\n        gap: 27px;\n    }\n\n    .auditionItem:nth-child(3) .auditionContent {\n        max-width: 1080px;\n        flex-flow: row;\n        flex-shrink: 0;\n        flex-wrap: wrap;\n        gap: 60px 27px;\n    }\n\n    .auditionContentSpace {\n        display: flex;\n        gap: 32px;\n    }\n\n    .auditionContentSpace > span:nth-child(1) {\n        width: 35px;\n    }\n\n    .auditionContentEx {\n        font-size: 26px;\n        color: #434343;\n    }\n\n    .auditionContentFlex {\n        display: flex;\n        gap: 24px;\n        flex-flow: column;\n        min-width: 420px;;\n    }\n\n    .flexContent2 > span {\n        display: block;\n        line-height: 40px;\n        color: #434343;\n        font-size: 26px;\n        font-weight: 400;\n        width: 420px;\n    }\n\n    .flexContent > span {\n        display: block;\n        line-height: 40px;\n        color: #434343;\n        font-size: 26px;\n        font-weight: 400;\n    }\n\n    .flexButton {\n        margin-top: 36px;\n        display: flex;\n        gap: 16px;\n    }\n\n    .downloadButton {\n        background-color: #DC140A;\n        width: auto;\n        height: 43px;\n        border-radius: 21px;\n        color: #FFFFFF;\n        font-size: 20px;\n        font-weight: bold;\n        padding: 0 32px;\n        display: flex;\n        justify-content: center;\n        gap: 16px;\n        align-items: center;\n        cursor: pointer;\n    }\n\n    .companyScrollBarContainer {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Pages_wrap__RNd7Q`,
	"container": `Pages_container__PBXjY`,
	"categoryContainer": `Pages_categoryContainer__bft+I`,
	"divUp": `Pages_divUp__BSs7x`,
	"commentContainer": `Pages_commentContainer__h049w`,
	"commentTheme": `Pages_commentTheme__8WO5p`,
	"commentContent": `Pages_commentContent__bd8-K`,
	"companyContainer": `Pages_companyContainer__9wazD`,
	"companyItem": `Pages_companyItem__CuDYU`,
	"companyItemImg": `Pages_companyItemImg__-W6hB`,
	"overlabB": `Pages_overlabB__hiGMR`,
	"overlabR": `Pages_overlabR__H4Ue3`,
	"companyItemTheme": `Pages_companyItemTheme__MH6ms`,
	"companyItemContent": `Pages_companyItemContent__pAau4`,
	"productionContainer": `Pages_productionContainer__xRb2Y`,
	"productionTheme": `Pages_productionTheme__aliXR`,
	"productionItemContainer": `Pages_productionItemContainer__HbvaK`,
	"productionItem": `Pages_productionItem__HitZU`,
	"productionItemImg": `Pages_productionItemImg__s3viy`,
	"productionItemInfoContainer": `Pages_productionItemInfoContainer__QLgLR`,
	"productionItemInfoWrap": `Pages_productionItemInfoWrap__RsUZz`,
	"productionItemInfo": `Pages_productionItemInfo__iCBZ7`,
	"productionItemTheme": `Pages_productionItemTheme__nQbUk`,
	"prodictionItemList": `Pages_prodictionItemList__O+mkA`,
	"listTheme": `Pages_listTheme__IoSRf`,
	"listContent": `Pages_listContent__MGHwh`,
	"productionNodataContainer": `Pages_productionNodataContainer__n0FYs`,
	"productionNoData": `Pages_productionNoData__sf1eO`,
	"producerItem": `Pages_producerItem__Jk9QW`,
	"producerItemInfo": `Pages_producerItemInfo__c1vbF`,
	"producerItemName": `Pages_producerItemName__aeOn7`,
	"producerItemWork": `Pages_producerItemWork__kPKTF`,
	"listArrow": `Pages_listArrow__0vfMo`,
	"workItem": `Pages_workItem__HSQLQ`,
	"auditionForm": `Pages_auditionForm__CYyLP`,
	"auditionItem": `Pages_auditionItem__pAw7q`,
	"auditionItemDiv": `Pages_auditionItemDiv__NAORU`,
	"auditionTheme": `Pages_auditionTheme__HNY-S`,
	"auditionContent": `Pages_auditionContent__u-ecD`,
	"auditionContentSpace": `Pages_auditionContentSpace__wR2NT`,
	"auditionContentEx": `Pages_auditionContentEx__pfGoi`,
	"auditionContentFlex": `Pages_auditionContentFlex__UuRTO`,
	"flexContent2": `Pages_flexContent2__vkP09`,
	"flexContent": `Pages_flexContent__RI7a0`,
	"flexButton": `Pages_flexButton__OKJh0`,
	"downloadButton": `Pages_downloadButton__mP1d9`,
	"companyScrollBarContainer": `Pages_companyScrollBarContainer__IfJHC`,
	"companyScrollBar": `Pages_companyScrollBar__pNuJh`,
	"companyScrollBarShow": `Pages_companyScrollBarShow__B455J`,
	"productionComment": `Pages_productionComment__Z7MMn`
};
export default ___CSS_LOADER_EXPORT___;
